import type { ReturnRequestDto } from "../generated/schema";
import { useInvalidateReturnRequest } from "./use-invalidate-return-request.ts";
import { useApiMutation } from "./use-api-mutation";

interface UseUpdateReturnRequestCarrierParams {
  onSuccess: (returnRequest: ReturnRequestDto) => void;
  onError?: (error: unknown) => void;
}

export default function useUpdateReturnRequestCarrier(
  params: UseUpdateReturnRequestCarrierParams,
) {
  const invalidateReturnRequest = useInvalidateReturnRequest();

  return useApiMutation(
    "patch",
    "/shops/{shopId}/return-requests/{returnRequestId}/carrier",
    {
      onSuccess(returnRequest) {
        params.onSuccess(returnRequest);
        setTimeout(
          () =>
            invalidateReturnRequest({
              returnRequestId: returnRequest.id,
              shopId: returnRequest.shopId,
            }),
          100,
        );
      },
      onError(err) {
        params.onError?.(err);
      },
    },
  );
}
